import React from 'react';
import {Box} from '@mui/material';
import {SendOutlined, TaskAltOutlined, TouchAppOutlined} from '@mui/icons-material';
import {SettingsEmptyState} from '../settings/SettingsDesign';

const icons = {clicks: TouchAppOutlined, conversions: TaskAltOutlined, postbacks: SendOutlined};

export default function LogEmptyState({kind}) {
    return (
        <Box
            role="status"
            sx={{
                position: 'absolute',
                top: 35,
                bottom: 0,
                left: 0,
                right: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none'
            }}>
            <SettingsEmptyState
                icon={icons[kind]}
                title="No records found"
                description={`No ${kind} match your filters. Adjust your search or date range to find matching records.`}
            />
        </Box>
    );
}
